import React from "react";
import Tooltip from "@/src/components/common/Elements/Tooltip/Tooltip";
import Invite from "../Invite/Invite";
import { UserStatusEnum } from "../../Modal/AddUser/Config";

const statuses = {
	disabled: "No access"
}

const FormRow = (props) => {
  const { 
    member, 
    isWorkStreamLead, 
    onRemoveMember,
    onInviteMember,
    actionsPermissions
  } = props;

  let actionButton = <button class="btnDelete active" onClick={() => onRemoveMember(member)} data-tooltip-id={`member-${member.id}-remove`}>
    {member.isRemoved && <span class="mr10">Removed</span>}
    <i class="material-icons">delete_outline</i>
    <Tooltip id={`member-${member.id}-remove`} place="bottom" effect="solid">
      Remove Member
    </Tooltip>
  </button>;

  if (member.memberType === "project manager") {
    actionButton = <button class="btnDelete disabled" data-tooltip-id={`member-${member.id}-remove`}>
      <i class="material-icons">delete_outline</i>
      <Tooltip id={`member-${member.id}-remove`} place="bottom" effect="solid">
        The Account Lead cannot be removed from an Account. Please select another user to be the Account Lead instead.
      </Tooltip>
    </button>;
  } else if (isWorkStreamLead) {
    actionButton = <button class="btnDelete disabled" data-tooltip-id={`member-${member.id}-remove`}>
      <i class="material-icons">delete_outline</i>
      <Tooltip id={`member-${member.id}-remove`} place="bottom" effect="solid">
        The selected user is a workstream lead. Please reassign the user from the workstream before removing them from the account.
      </Tooltip>
    </button>
  }

  return (
    <tr class={`${member.isRemoved ? "removed" : ""}`}>
      <td>{member.name ? member.name : (member.user ? `${member.user['first-name'] || ''} ${member.user['last-name'] || ''}` : '')}</td>
      <td>{member.email}</td>
      <td>{member.position ? member.position : "--"}</td>
      <td>{member.role}</td>
      <td class="status">
        {statuses[member.status] ? statuses[member.status] : member.status}
        {member.user_status === UserStatusEnum.DEACTIVATED && (
          <React.Fragment>
            <i class="material-icons" data-tooltip-id={`member-${member.id}-info`}>info</i>
            <Tooltip id={`member-${member.id}-info`} place="right" effect="solid">
              This user has been Deactivated
            </Tooltip>
          </React.Fragment>
        )}
      </td>
      {actionsPermissions && (
        <td class="actionMainContainer">
          <div class="actionContainer">
            {!member.isRemoved && <Invite member={member} onUpdateMember={onInviteMember} />}
            {actionButton}
          </div>
        </td>
      )}
    </tr>
  );
}

export default FormRow;